/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    COMPLETED: 'completed', // user registered himself and confirmed a password for his account
    UNCONFIRMED_EMAIL: 'unconfirmed_email', // user registered himself but did not confirm and set a password yet
    INVITED_TO_CREATE_ACCOUNT: 'invited_to_create_account', // invited client or employee by studio - did not confirm login and did not set a password yet
    NO_EMAIL: 'no_email',
    ANONYMOUS: 'anonymous', // he created a reservation with an email but did not creat Fyooga account
};
